<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-exchange-sidebar>
  <app-crud-table body [crudService]="crudService"
                   [transPartKey]="'broker-code'" [fieldId]="'id'" [fieldName]="'code'"
                   [tableConfig]="tableConfig" [newRecord]="newRecord"
                   [(formRecord)]="formRecord" [formConfig]="formConfig"
                   (dialogFormVisibleChange)="$event?onFormShow():{}"
                   [formLoading]="formLoading"
                   [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
                   [writeRoles]="CCRoles.ROLES_EXCHANGE_WRITE"
                   [prepareForClone]="prepareRecordForClone" [totalRecords]="totalRecords"
  ></app-crud-table>
</app-exchange-sidebar>
